import { isEqual, uniq } from 'lodash';

import { RecipeDropdownTabs } from '../enums/contentTabs';
import { RecipeModel } from '../interface/inspirations-and-planning';
import { OptionsType } from '../types/content';

export function filterSelectedDropdownValue(
  currentOption: OptionsType,
  selectAll,
  otherOption,
  content
) {
  return isEqual(currentOption.tab, selectAll)
    ? content
    : isEqual(otherOption, currentOption.value);
}

export function generateFoodtypesByCourse(
  currentCourseOption: OptionsType,
  recipesContent: RecipeModel[]
) {
  const filteredRecipesContentByCourse = recipesContent.filter((recipeItem) => {
    return isEqual(currentCourseOption.tab, RecipeDropdownTabs.ALL_COURSES)
      ? true
      : recipeItem.attributes.courses.includes(currentCourseOption.value);
  });

  const foodtypesByCourseList = [];
  filteredRecipesContentByCourse.forEach((filteredItem) => {
    foodtypesByCourseList.push(filteredItem.attributes.food_type);
  });

  const foodtypesByCourseTabs = uniq(foodtypesByCourseList.flat()).map(
    (foodTypeOption) => {
      return {
        tab: foodTypeOption,
        value: foodTypeOption
      };
    }
  );

  return foodtypesByCourseTabs;
}

export function generateProductTypesByFilteredRecipes(filteredRecipesContent) {
  const productType = [];
  filteredRecipesContent.forEach((filteredItem) => {
    productType.push(filteredItem.attributes.category);
  });

  const productTypesList = uniq(productType.flat());
  const productTypesByFilteredRecipes = productTypesList.map(
    (productOption) => {
      return {
        tab: productOption,
        value: productOption
      };
    }
  );

  return productTypesByFilteredRecipes;
}
